import { Components, Theme } from '@mui/material/styles';

import * as Colors from 'src/theme/colors';

const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: Colors.HoverNonBorderBackground,
      },
      height: '35.5px',
      paddingLeft: '16px',
    },
  },
};

export default MuiListItemButton;
